export const MARKET_PLACE_POLICIES_RESET_STATE = 'MARKET_PLACE_POLICIES_RESET_STATE';
export const MARKET_PLACE_POLICIES_CURRENT_ITEM = 'MARKET_PLACE_POLICIES_CURRENT_ITEM';

export const MARKET_PLACE_POLICIES_REQUEST_LOADING = 'MARKET_PLACE_POLICIES_REQUEST_LOADING';
export const MARKET_PLACE_POLICIES_REQUEST_SUCCESS = 'MARKET_PLACE_POLICIES_REQUEST_SUCCESS';
export const MARKET_PLACE_POLICIES_REQUEST_FAILED = 'MARKET_PLACE_POLICIES_REQUEST_FAILED';

export const MARKET_PLACE_POLICIES_CURRENT_ACTION = 'MARKET_PLACE_POLICIES_CURRENT_ACTION';
export const MARKET_PLACE_POLICIES_RESET_ACTION = 'MARKET_PLACE_POLICIES_RESET_ACTION';